<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="m12 15.58-3.54-3.54.7-.72 2.34 2.33V5h1v8.65l2.33-2.33.7.72zM6.62 19q-.7 0-1.16-.46T5 17.38v-2.42h1v2.42q0 .24.2.43.18.2.42.19h10.76q.24 0 .43-.2.2-.18.19-.42v-2.42h1v2.42q0 .7-.46 1.16t-1.16.46z"
      />
    </svg>
  </span>
</template>
